// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyBiPolicyHolder } from './pharmacyBiPolicyHolder.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiPolicy {
    'number'?: string | null;
    'type'?: string | null;
    'holder'?: PharmacyBiPolicyHolder | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiPolicy>> = [
        {
            "name":     "number",
            "baseName": "number",
            "type":     "string"
        },
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
        {
            "name":     "holder",
            "baseName": "holder",
            "type":     "PharmacyBiPolicyHolder"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiPolicy.attributeTypeMap;
    }
}
